(function () {
  var config = window.FFKlaviyoConfig || {};
  var companyId = config.companyId;
  var configuredRevision = String(config.revision || '').trim();
  var revision = /^\d{4}-\d{2}-\d{2}(?:\.[A-Za-z0-9_-]+)?$/.test(configuredRevision)
    ? configuredRevision
    : '2026-04-15';

  if (!companyId) return;

  if (configuredRevision && configuredRevision !== revision && window.console && window.console.warn) {
    window.console.warn('[Father Fortified] Ignoring invalid Klaviyo API revision:', configuredRevision);
  }

  var endpoint = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId);
  var emailSelectors = [
    'input[name="contact[email]"]',
    'input[name="customer[email]"]',
    'input[name="email"]',
    'input[type="email"]'
  ];
  var phoneSelectors = [
    'input[name="contact[phone]"]',
    'input[name="customer[phone]"]',
    'input[name="phone"]',
    'input[type="tel"]'
  ];

  function normalizeKey(value) {
    return String(value || '').trim().toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function findValue(form, selectors) {
    for (var i = 0; i < selectors.length; i += 1) {
      var field = form.querySelector(selectors[i]);
      if (field && field.value && field.value.trim()) {
        return field.value.trim();
      }
    }
    return '';
  }

  function fieldValue(form, name) {
    var field = form.querySelector('[name="' + name + '"]');
    return field && field.value ? field.value.trim() : '';
  }

  function splitName(name) {
    var parts = String(name || '').trim().split(/\s+/).filter(Boolean);
    return {
      first: parts.shift() || '',
      last: parts.join(' ')
    };
  }

  function normalizePhone(value) {
    var raw = String(value || '').trim();
    if (!raw) return '';
    if (raw.charAt(0) === '+') return raw.replace(/[^\d+]/g, '');

    var digits = raw.replace(/\D/g, '');
    if (digits.length === 10) return '+1' + digits;
    if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
    return '';
  }

  function contactReason(form) {
    return fieldValue(form, 'contact[reason]') || form.getAttribute('data-ff-klaviyo-reason') || '';
  }

  function listIdForForm(form) {
    var listId = form.getAttribute('data-ff-klaviyo-list-id') || '';
    var routing = form.getAttribute('data-ff-klaviyo-routing');

    if (routing === 'contact') {
      var reason = normalizeKey(contactReason(form));
      var contactMap = config.contactReasonLists || {};
      if (reason && contactMap[reason]) {
        listId = contactMap[reason];
      }
    }

    return listId;
  }

  function channelsForForm(form, email, phone) {
    var raw = form.getAttribute('data-ff-klaviyo-channel') || 'email';
    var requested = raw.split(',').map(function (channel) {
      return normalizeKey(channel);
    });
    var subscriptions = {};

    if (email && requested.indexOf('email') !== -1) {
      subscriptions.email = {
        marketing: {
          consent: 'SUBSCRIBED'
        }
      };
    }

    if (phone && requested.indexOf('sms') !== -1) {
      subscriptions.sms = {
        marketing: {
          consent: 'SUBSCRIBED'
        }
      };
    }

    return subscriptions;
  }

  function addIfPresent(target, key, value) {
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      target[key] = String(value).trim();
    }
  }

  function profileProperties(form, listId) {
    var properties = {
      ff_form_source: form.getAttribute('data-ff-klaviyo-source') || 'Father Fortified website',
      ff_form_id: form.id || '',
      ff_list_id: listId,
      ff_page_path: window.location.pathname,
      ff_page_url: window.location.href.split('#')[0],
      ff_submitted_at: new Date().toISOString()
    };

    addIfPresent(properties, 'ff_shopify_tags', fieldValue(form, 'contact[tags]') || fieldValue(form, 'customer[tags]'));
    addIfPresent(properties, 'ff_contact_reason', contactReason(form));
    addIfPresent(properties, 'ff_training_identity', fieldValue(form, 'contact[training_identity]') || form.getAttribute('data-ff-training-identity'));
    addIfPresent(properties, 'ff_discount_tier', fieldValue(form, 'contact[discount_tier]') || form.getAttribute('data-ff-discount-tier'));
    addIfPresent(properties, 'ff_order_number', fieldValue(form, 'contact[order_number]'));
    addIfPresent(properties, 'ff_coupon_code', form.getAttribute('data-ff-klaviyo-coupon'));
    addIfPresent(properties, 'ff_product_title', form.getAttribute('data-ff-klaviyo-product-title'));
    addIfPresent(properties, 'ff_product_handle', form.getAttribute('data-ff-klaviyo-product-handle'));
    addIfPresent(properties, 'ff_product_url', form.getAttribute('data-ff-klaviyo-product-url'));

    return properties;
  }

  function profileAttributes(form, listId) {
    var email = findValue(form, emailSelectors);
    var phone = normalizePhone(findValue(form, phoneSelectors));
    var fullName = fieldValue(form, 'contact[name]') || fieldValue(form, 'customer[name]') || fieldValue(form, 'name');
    var firstName = fieldValue(form, 'customer[first_name]');
    var lastName = fieldValue(form, 'customer[last_name]');
    var nameParts = splitName(fullName);
    var attributes = {
      properties: profileProperties(form, listId)
    };

    addIfPresent(attributes, 'email', email);
    addIfPresent(attributes, 'phone_number', phone);
    addIfPresent(attributes, 'first_name', firstName || nameParts.first);
    addIfPresent(attributes, 'last_name', lastName || nameParts.last);

    var subscriptions = channelsForForm(form, email, phone);
    if (Object.keys(subscriptions).length) {
      attributes.subscriptions = subscriptions;
    }

    return attributes;
  }

  function payloadForForm(form) {
    var listId = listIdForForm(form);
    if (!listId) return null;

    var attributes = profileAttributes(form, listId);
    if (!attributes.email && !attributes.phone_number) return null;
    if (!attributes.subscriptions || !Object.keys(attributes.subscriptions).length) return null;

    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: form.getAttribute('data-ff-klaviyo-source') || 'Father Fortified website',
          profile: {
            data: {
              type: 'profile',
              attributes: attributes
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
    };
  }

  async function postPayload(payload) {
    var controller = window.AbortController ? new AbortController() : null;
    var timeout = controller ? window.setTimeout(function () {
      controller.abort();
    }, 4500) : null;

    try {
      var response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          'content-type': 'application/vnd.api+json',
          revision: revision
        },
        body: JSON.stringify(payload),
        credentials: 'omit',
        signal: controller ? controller.signal : undefined
      });

      var responseText = '';
      try {
        responseText = await response.text();
      } catch (error) {}

      window.FFKlaviyoLastResponse = {
        ok: response.ok,
        status: response.status,
        body: responseText,
        revision: revision
      };

      if (!response.ok && window.console && window.console.warn) {
        window.console.warn('[Father Fortified] Klaviyo capture failed:', response.status, responseText);
      }

      return response.ok;
    } catch (error) {
      window.FFKlaviyoLastResponse = {
        ok: false,
        status: 0,
        body: error && error.message ? error.message : String(error),
        revision: revision
      };
      if (window.console && window.console.warn) {
        window.console.warn('[Father Fortified] Klaviyo capture skipped:', error && error.message ? error.message : error);
      }
      return false;
    } finally {
      if (timeout) window.clearTimeout(timeout);
    }
  }

  async function captureForm(form) {
    if (!form) return false;

    var payload = payloadForForm(form);
    if (!payload) return false;

    return postPayload(payload);
  }

  function shopifyContactUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return root.replace(/\/?$/, '/') + 'contact';
  }

  function shopifyPayloadForForm(form) {
    var email = findValue(form, emailSelectors);
    if (!email) return null;

    var params = new URLSearchParams();
    var formData = new FormData(form);

    formData.forEach(function (value, key) {
      if (typeof value === 'string') {
        params.append(key, value);
      }
    });

    params.set('form_type', 'customer');
    if (!params.has('utf8')) params.set('utf8', '✓');
    params.set('contact[email]', email);
    if (!params.has('contact[accepts_marketing]')) params.set('contact[accepts_marketing]', 'true');
    if (!params.has('contact[tags]') || !params.get('contact[tags]')) {
      params.set('contact[tags]', 'Lead Capture, Website Popup');
    }

    var phone = normalizePhone(findValue(form, phoneSelectors));
    if (phone) params.set('contact[phone]', phone);

    return params;
  }

  async function submitShopifyCustomer(form) {
    if (!form) return false;

    var params = shopifyPayloadForForm(form);
    if (!params) return false;

    try {
      var response = await fetch(shopifyContactUrl(), {
        method: 'POST',
        headers: {
          accept: 'text/html,application/xhtml+xml',
          'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: params.toString(),
        credentials: 'same-origin',
        redirect: 'follow'
      });

      window.FFKlaviyoLastShopifyResponse = {
        ok: response.ok,
        status: response.status
      };

      if (!response.ok && window.console && window.console.warn) {
        window.console.warn('[Father Fortified] Shopify customer capture failed:', response.status);
      }

      return response.ok;
    } catch (error) {
      window.FFKlaviyoLastShopifyResponse = {
        ok: false,
        status: 0,
        body: error && error.message ? error.message : String(error)
      };
      if (window.console && window.console.warn) {
        window.console.warn('[Father Fortified] Shopify customer capture skipped:', error && error.message ? error.message : error);
      }
      return false;
    }
  }

  function nativeSubmit(form) {
    form.setAttribute('data-ff-klaviyo-submitted', 'true');
    if (HTMLFormElement.prototype.submit) {
      HTMLFormElement.prototype.submit.call(form);
    } else {
      form.submit();
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target && event.target.closest ? event.target.closest('form[data-ff-klaviyo-form]') : null;
    if (!form || form.getAttribute('data-ff-klaviyo-async') === 'true') return;
    if (form.getAttribute('data-ff-klaviyo-submitted') === 'true') return;

    event.preventDefault();

    var submitter = event.submitter || form.querySelector('[type="submit"]');
    if (submitter) {
      submitter.setAttribute('aria-busy', 'true');
      submitter.disabled = true;
    }

    captureForm(form).finally(function () {
      nativeSubmit(form);
    });
  }, true);

  window.FFKlaviyo = {
    captureForm: captureForm,
    submitShopifyCustomer: submitShopifyCustomer,
    listIdForForm: listIdForForm
  };
})();
